import { React, useState, useEffect } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  LinearProgress,
} from "@mui/material";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../api_Routes";
import { useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import { showIconByServiceId } from "../../../helpers/showIconByServiceId";
import SwitchButton from "./switch-button";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {useCenteredSnackbar} from "../../../tools/useCenteredSnackbar";

const OrderHistory = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar,closeSnackbar } = useSnackbar();
    const { showCenteredPopup } = useCenteredSnackbar();
  const [option, setOption] = useState("service");
  const baseApi = api_Routes.Providers.getPanelsByAuth;
  // option === "service"
  //   ? api_Routes.dashboard.orderhistory.view
  //   : api_Routes.dashboard.orderhistory.viewByOffer;
  const [history, setHistory] = useState([]);
  const [pageloading, setPageLoading] = useState(true); // State for loading
  const [selectedFilter, setSelectedFilter] = useState("all");


    const action = key => (
        <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={() => closeSnackbar(key)}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
  useEffect(() => {
    Order_History();
  }, [selectedFilter, option]);

  const Order_History = async () => {
    setPageLoading(true); // Show loader
    let url = baseApi;
    console.log(url);
    // if (selectedFilter !== "all") {
    //   url = `${baseApi}?status=${selectedFilter}`;
    // }

    const { response, message } = await Helper.Get({
      url,
      hasToken: true,
    });
    console.log(response);
    if (response) {
      setHistory(
        response.data.map((history) => ({
          request_id: history.panel_details.id,
          panel_url: history.panel_details.url,
          title: history.title,
          description: history.panel_details.description,
          status: history.status,
          status_payment: history.status_payment,
          panelName: history.panel_details.name,
          userName: history.userName,
          logo: history.panel_details.logo,
          customLogo: history.panel_details.customLogo,
          ourServiceName: history.panel_details.name,
          // ourServiceNameId: history.panel_details.name,
          ourServiceTypeId: history.ourServiceTypeId,
          email: history.panel_details.email,
          report: history.report,
        }))
      );
    } else {
    }
    setPageLoading(false); // Hide loader
  };

  const handleFilterChange = (filter) => {
    setSelectedFilter(filter);
  };

  const handleDownload = async (report) => {
    try {
      const link = document.createElement("a");
      link.href = report;
      link.setAttribute("download", "image.jpg");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
        showCenteredPopup(error || "Failed to download report",
            { variant: "error",
                persist: true });
      // enqueueSnackbar(error || "Failed to download report", {
      //   variant: "error",
      //     persist: true,
      //     action,
      // });
    }
  };

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: "#474747",
            fontSize: "24px",
            lineHeight: "30px",
            fontWeight: "600",
          }}
        >
          My Panels
        </Typography>
        {/* <Box>
          <SwitchButton orderOption={option} setOrderOption={setOption} />
        </Box>
        <Box
          sx={{
            display: { sm: "flex", xs: "grid" },
            gridTemplateColumns: { sm: "auto", xs: "1fr 1fr" },
            flexDirection: "row",
            gap: "10px",
            marginTop: "20px",
          }}
        >
          {["all", "pending", "in_progress", "complete"].map((filter) => (
            <Button
              key={filter}
              variant={selectedFilter === filter ? "contained" : "outlined"}
              sx={{
                "&:hover": {
                  backgroundColor: "#3F78E0",
                  color: "white",
                },
                borderRadius: "5px",
                border: "2px solid #3F78E0",
                color: selectedFilter === filter ? "white" : "#303030",
                fontSize: "14px",
                fontWeight: "600",
                paddingBlock: "10px",
                lineHeight: "18px",
                width: { sm: "130px", xs: "100%" },
                backgroundColor:
                  selectedFilter === filter ? "#3F78E0" : "white",
              }}
              onClick={() => handleFilterChange(filter)}
            >
              {filter.replace("_", " ")}
            </Button>
          ))}
        </Box> */}

        {/* Show loader when pageloading is true */}
        {pageloading && (
          <Box sx={{ width: "100%", marginTop: "10px" }}>
            <LinearProgress />
          </Box>
        )}

        <TableContainer
          component={Paper}
          sx={{
            boxShadow: "none",
            border: "2px solid #3F78E0",
            marginTop: "20px",
          }}
        >
          {history?.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow
                  sx={{
                    backgroundColor: "#D1DDE4",
                  }}
                >
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    ID
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    Logo
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    Panel Name
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    Panel url
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    Contact Email
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    Description
                  </TableCell>
                  {/* 
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    Status
                  </TableCell>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    Status payment
                  </TableCell> */}
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      borderInlineEnd: "1px solid #3F78E0",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {history.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      backgroundColor: "#E5EDFF",
                      borderBlock: "2px solid #3F78E0",
                    }}
                  >
                    <TableCell
                      sx={{
                        textAlign: "center",
                        color: "#333333",
                        borderInlineEnd: "1px solid #3F78E0",
                      }}
                    >
                      {row.request_id}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                        color: "#333333",
                      }}
                    >
                      {/* <Box
                        className="icons"
                        sx={{
                          height: "40px",
                          display: "flex",
                          gap: "8px",
                          justifyContent: "center",
                          overflow: "hidden",
                          width: "100%",
                          paddingInline: "5px",
                        }}
                      >
                        {row?.ourServiceNameId ? (
                          <img
                            src={showIconByServiceId(row?.ourServiceNameId)}
                            alt="icon"
                            key={index}
                            style={{
                              height: "100%",
                              maxWidth: "50px",
                              objectFit: "contain",
                            }}
                          />
                        ) : (
                          "x"
                        )}
                      </Box> */}

                      <div className="logo-container">
                        {row?.logo ? (
                          <img
                            src={row?.logo || row?.customLogo}
                            alt="panel_logo"
                            className="panel-logo"
                          />
                        ) : (
                          <div className="final-logo-container">
                            <Typography
                              sx={{
                                fontSize: `${
                                  row?.customLogo?.fontSize
                                    ? `${row?.customLogo?.fontSize}px`
                                    : "25px"
                                }`,
                                color: `${row?.customLogo?.color || "#FFFFFF"}`,
                                fontFamily: `${
                                  row?.customLogo?.fontFamily || "Mockads"
                                }`,
                                background:
                                  "radial-gradient(circle, #51AAFD, #002D68)",
                                display: "flex",
                                justifyContent: "center",
                                height: "30px",
                              }}
                              className="final-logo"
                            >
                              {row?.customLogo?.logoName || row?.name}
                            </Typography>
                          </div>
                        )}{" "}
                      </div>

                      {/* <Box
                              sx={{
                                background: "radial-gradient(circle, #51AAFD, #002D68)",
                                display: "flex",
                                justifyContent: "center",
                                height: "198px",
                                alignItems: "center",
                                position: "relative",
                              }}
                            >
                              {row?.trust === 1 && (
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: "10px",
                                    right: "10px",
                                  }}
                                >
                                  <svg
                                    width="90"
                                    height="30"
                                    viewBox="0 0 74 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                      x="0.9375"
                                      y="0.492188"
                                      width="72"
                                      height="20"
                                      rx="10"
                                      fill="white"
                                    />
                                    <rect
                                      x="0.9375"
                                      y="0.492188"
                                      width="72"
                                      height="20"
                                      rx="10"
                                      stroke="white"
                                    />
                                    <path
                                      d="M25.3378 6.99219H30.8378V7.98219H28.6878V13.9922H27.4978V7.98219H25.3378V6.99219ZM31.8682 8.99219H32.8882L32.9782 9.61219C33.1116 9.44552 33.2682 9.30885 33.4482 9.20219C33.6282 9.08885 33.8216 9.01219 34.0282 8.97219C34.2416 8.93219 34.4549 8.93885 34.6682 8.99219V10.0322C34.4949 9.97219 34.3082 9.95885 34.1082 9.99219C33.9149 10.0189 33.7349 10.0922 33.5682 10.2122C33.4016 10.3255 33.2649 10.4889 33.1582 10.7022C33.0516 10.9089 32.9982 11.1655 32.9982 11.4722V13.9922H31.8682V8.99219ZM39.8396 13.9922H38.7996L38.7296 13.4922C38.563 13.6722 38.363 13.8122 38.1296 13.9122C37.8963 14.0122 37.6496 14.0622 37.3896 14.0622C36.9963 14.0622 36.6563 13.9822 36.3696 13.8222C36.0896 13.6555 35.873 13.4155 35.7196 13.1022C35.5663 12.7822 35.4896 12.3889 35.4896 11.9222V8.99219H36.6196V11.7722C36.6196 12.1855 36.703 12.5022 36.8696 12.7222C37.0363 12.9355 37.293 13.0422 37.6396 13.0422C37.973 13.0422 38.233 12.9355 38.4196 12.7222C38.613 12.5022 38.7096 12.1789 38.7096 11.7522V8.99219H39.8396V13.9922ZM41.8754 12.3822C41.922 12.5689 42.002 12.7122 42.1154 12.8122C42.2354 12.9122 42.3654 12.9822 42.5054 13.0222C42.6454 13.0555 42.7787 13.0722 42.9054 13.0722C43.1654 13.0722 43.3687 13.0222 43.5154 12.9222C43.6687 12.8155 43.7454 12.6822 43.7454 12.5222C43.7454 12.3889 43.6954 12.2855 43.5954 12.2122C43.4954 12.1389 43.3654 12.0822 43.2054 12.0422C43.052 11.9955 42.892 11.9489 42.7254 11.9022C42.5454 11.8555 42.352 11.8022 42.1454 11.7422C41.9454 11.6822 41.7554 11.5989 41.5754 11.4922C41.3954 11.3855 41.2487 11.2489 41.1354 11.0822C41.022 10.9155 40.9654 10.7089 40.9654 10.4622C40.9654 10.1489 41.052 9.87885 41.2254 9.65219C41.3987 9.41885 41.6354 9.23885 41.9354 9.11219C42.2354 8.98552 42.572 8.92219 42.9454 8.92219C43.392 8.92219 43.7787 9.01552 44.1054 9.20219C44.432 9.38885 44.6687 9.66219 44.8154 10.0222L43.8254 10.3422C43.7787 10.2489 43.7087 10.1689 43.6154 10.1022C43.5287 10.0355 43.422 9.98885 43.2954 9.96219C43.1754 9.92885 43.052 9.91219 42.9254 9.91219C42.712 9.91219 42.532 9.95552 42.3854 10.0422C42.2387 10.1289 42.1654 10.2522 42.1654 10.4122C42.1654 10.4922 42.1887 10.5622 42.2354 10.6222C42.2887 10.6822 42.3587 10.7322 42.4454 10.7722C42.532 10.8055 42.6354 10.8389 42.7554 10.8722C42.8754 10.8989 43.002 10.9322 43.1354 10.9722C43.3487 11.0322 43.5587 11.0989 43.7654 11.1722C43.9787 11.2389 44.172 11.3255 44.3454 11.4322C44.5254 11.5389 44.6654 11.6789 44.7654 11.8522C44.872 12.0255 44.932 12.2455 44.9454 12.5122C44.9454 12.7989 44.862 13.0622 44.6954 13.3022C44.5287 13.5355 44.2887 13.7222 43.9754 13.8622C43.6687 13.9955 43.302 14.0622 42.8754 14.0622C42.382 14.0622 41.9587 13.9555 41.6054 13.7422C41.252 13.5289 41.012 13.1855 40.8854 12.7122L41.8754 12.3822ZM46.3289 8.99219V7.59219H47.4789V8.99219H48.6489V9.98219H47.4789V12.2022C47.4789 12.5022 47.5355 12.7122 47.6489 12.8322C47.7622 12.9455 47.9089 13.0089 48.0889 13.0222C48.2755 13.0289 48.4622 13.0189 48.6489 12.9922V13.9522C48.3622 14.0122 48.0789 14.0289 47.7989 14.0022C47.5255 13.9822 47.2789 13.9089 47.0589 13.7822C46.8389 13.6489 46.6622 13.4555 46.5289 13.2022C46.3955 12.9489 46.3289 12.6155 46.3289 12.2022V9.98219H45.6289V8.99219H46.3289ZM51.8621 14.0622C51.3621 14.0622 50.9221 13.9522 50.5421 13.7322C50.1688 13.5122 49.8755 13.2055 49.6621 12.8122C49.4555 12.4189 49.3521 11.9655 49.3521 11.4522C49.3521 10.9655 49.4555 10.5322 49.6621 10.1522C49.8688 9.77219 50.1555 9.47219 50.5221 9.25219C50.8888 9.03219 51.3055 8.92219 51.7721 8.92219C52.2455 8.92219 52.6621 9.02552 53.0221 9.23219C53.3821 9.43885 53.6621 9.72885 53.8621 10.1022C54.0688 10.4689 54.1721 10.8955 54.1721 11.3822C54.1721 11.4622 54.1688 11.5489 54.1621 11.6422C54.1555 11.7289 54.1455 11.8222 54.1321 11.9222H50.5721C50.6055 12.1555 50.6788 12.3589 50.7921 12.5322C50.9121 12.6989 51.0621 12.8289 51.2421 12.9222C51.4221 13.0155 51.6288 13.0622 51.8621 13.0622C52.1421 13.0622 52.3921 13.0055 52.6121 12.8922C52.8388 12.7789 52.9955 12.6289 53.0821 12.4422L54.0721 12.7722C53.8721 13.1722 53.5755 13.4889 53.1821 13.7222C52.7888 13.9489 52.3488 14.0622 51.8621 14.0622ZM52.9421 11.0022C52.9355 10.7955 52.8788 10.6089 52.7721 10.4422C52.6655 10.2755 52.5255 10.1455 52.3521 10.0522C52.1788 9.95219 51.9855 9.90219 51.7721 9.90219C51.5855 9.90219 51.4088 9.94885 51.2421 10.0422C51.0755 10.1355 50.9321 10.2655 50.8121 10.4322C50.6988 10.5922 50.6255 10.7822 50.5921 11.0022H52.9421ZM58.9174 9.73219L58.7874 9.76219V6.79219H59.9174V13.9922H58.8974L58.8174 13.3722C58.644 13.5655 58.424 13.7289 58.1574 13.8622C57.8907 13.9955 57.574 14.0622 57.2074 14.0622C56.7607 14.0622 56.3674 13.9555 56.0274 13.7422C55.694 13.5289 55.434 13.2289 55.2474 12.8422C55.0607 12.4555 54.9674 12.0055 54.9674 11.4922C54.9674 10.9789 55.0607 10.5289 55.2474 10.1422C55.434 9.75552 55.694 9.45552 56.0274 9.24219C56.3674 9.02885 56.7607 8.92219 57.2074 8.92219C57.6007 8.92219 57.944 9.00219 58.2374 9.16219C58.5307 9.31552 58.7574 9.50552 58.9174 9.73219ZM56.1774 11.4922C56.1774 11.9522 56.2974 12.3255 56.5374 12.6122C56.7774 12.8989 57.0907 13.0422 57.4774 13.0422C57.7107 13.0422 57.924 12.9822 58.1174 12.8622C58.3174 12.7422 58.4774 12.5689 58.5974 12.3422C58.724 12.1089 58.7874 11.8255 58.7874 11.4922C58.7874 11.1589 58.724 10.8789 58.5974 10.6522C58.4774 10.4189 58.3174 10.2422 58.1174 10.1222C57.924 10.0022 57.7107 9.94219 57.4774 9.94219C57.0907 9.94219 56.7774 10.0855 56.5374 10.3722C56.2974 10.6589 56.1774 11.0322 56.1774 11.4922Z"
                                      fill="#004571"
                                    />
                                    <path
                                      d="M16.6729 15.872C16.557 15.872 16.4411 15.8537 16.3307 15.817C13.9657 15.0315 12.4375 13.1506 12.4375 11.0254V7.27204C12.4375 6.88981 12.7097 6.56294 13.0847 6.49476C14.2845 6.27644 15.3296 5.82651 16.1912 5.15742C16.475 4.93705 16.8709 4.93717 17.1544 5.15742C18.0161 5.82651 19.0612 6.27644 20.261 6.49476C20.636 6.56294 20.9082 6.88981 20.9082 7.27204V11.0254C20.9082 13.1506 19.38 15.0315 17.015 15.817C16.9048 15.8537 16.7888 15.872 16.6729 15.872ZM16.6729 5.71796C16.6599 5.71796 16.6468 5.72207 16.6362 5.73041C15.6815 6.47179 14.5304 6.96911 13.2147 7.20846C13.1847 7.2139 13.1628 7.24074 13.1628 7.27204V11.0254C13.1628 12.8327 14.496 14.4432 16.5594 15.1287C16.6327 15.153 16.7133 15.153 16.7864 15.1287C18.8498 14.4434 20.1829 12.8327 20.1829 11.0254V7.27204C20.1829 7.24061 20.1611 7.2139 20.1313 7.20846C18.8155 6.96911 17.6643 6.47179 16.7095 5.73041C16.6989 5.72219 16.686 5.71796 16.6729 5.71796Z"
                                      fill="#004571"
                                    />
                                    <path
                                      d="M16.0359 12.3316C15.9033 12.3316 15.7782 12.2737 15.6961 12.1745L14.4113 10.6203C14.2633 10.4413 14.2956 10.182 14.4832 10.0411C14.6708 9.90003 14.9428 9.93082 15.0908 10.1097L16.0359 11.2528L18.2656 8.55554C18.4135 8.37667 18.6855 8.34601 18.8734 8.48694C19.061 8.62786 19.0932 8.8873 18.9453 9.06617L16.3757 12.1745C16.2937 12.2737 16.1684 12.3316 16.0359 12.3316Z"
                                      fill="#004571"
                                    />
                                  </svg>
                                </Box>
                              )}
                      
                              <div className="final-logo-container">
                                <Typography
                                  sx={{
                                    fontSize: "24px",
                                    color: row?.logo?.color,
                                    fontFamily: row?.logo?.fontFamily,
                                    textAlign: "center",
                                  }}
                                  className="final-logo"
                                >
                                  {row?.logo?.logoName || "LOREM"}
                                </Typography>
                              </div>
                            </Box> */}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                        color: "#333333",
                      }}
                    >
                      {row.ourServiceName}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                        color: "#333333",
                      }}
                    >
                      {row.panel_url}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                        color: "#333333",
                      }}
                    >
                      {row.email}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                        color: "#333333",
                      }}
                    >
                      {row.description}
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                        color: "#333333",
                      }}
                    >
                      {row.status}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: "center",
                        borderInlineEnd: "1px solid #3F78E0",
                        color: "#333333",
                      }}
                    >
                      {row.status_payment}
                    </TableCell> */}
                    <TableCell
                      sx={{
                        textAlign: "center",
                        color: "#333333",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      {row?.ourServiceNameId === 1 ||
                      row?.ourServiceNameId === 10 ||
                      row?.ourServiceNameId === 11 ||
                      row?.ourServiceNameId === 9 ? (
                        <Button
                          sx={{
                            background: "#ECA601",
                            boxShadow: `
                          0px 3px 3px #00000040, 
                          inset 0px 4px 7px #FFFFFF40
                        `,
                            color: "white",
                            borderRadius: "6px",
                            width: "85px",
                            fontSize: "12px",
                          }}
                          onClick={() =>
                            navigate(
                              `/dashboard/order-history/service-statistic/${row?.request_id}`
                            )
                          }
                        >
                          Statistics
                        </Button>
                      ) : (
                        row?.report && (
                          <Button
                            sx={{
                              backgroundColor: "#ECA601",
                              boxShadow: `
                         0px 3px 3px #00000040, 
                         inset 0px 4px 7px #FFFFFF40
                       `,
                              color: "white",
                              borderRadius: "6px",
                              width: "85px",
                              fontSize: "12px",
                            }}
                            onClick={() => handleDownload(row?.report)}
                          >
                            Report
                          </Button>
                        )
                      )}
                      <Button
                        sx={{
                          backgroundColor: "#3F78E0",
                          color: "#fff",
                          boxShadow: `
                          0px 3px 3px #00000040, 
                          inset 0px 4px 7px #FFFFFF40
                        `,
                          marginTop: "30px",
                          borderRadius: "6px",
                          width: "85px",
                          fontSize: "12px",
                        }}
                        onClick={() => {
                          navigate(`/dashboard/mypanelId/${row?.request_id}`);
                        }}
                      >
                        Details
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#D1DDE4" }}>
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#333333",
                      textAlign: "center",
                      border: "1px solid #3F78E0",
                    }}
                  >
                    there are no data yet
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          )}
        </TableContainer>
      </Box>
    </>
  );
};

export default OrderHistory;
